import * as React from 'react';
import {Button} from '../../../../shared/components/button';
import {Form} from '../../../../shared/components/form';
import {StyleHelper, useStyles} from '../../../../shared/hooks/styles';
import {DeviceSize, useDeviceSize} from '../../../../shared/theme/helpers';
import {LoginLayout} from '../../components/layout';
import {PasswordFields} from '../../registratonOrRecovery/passwordFields';
import {createStyles} from '../../registratonOrRecovery/view';

interface ViewProps {
  isSubmitDisabled: boolean;
  onSubmit: (e?: any) => void;
}

export default ({isSubmitDisabled, onSubmit}: ViewProps) => {
  const deviceSize = useDeviceSize();
  const styles = useStyles((styleHelper: StyleHelper) => createStyles(styleHelper));

  return (
    <LoginLayout
      title='Восстановление пароля'
      // eslint-disable-next-line react-native/no-inline-styles
      titleStyle={{marginBottom: deviceSize === DeviceSize.mobile ? -60 : 0}}>
      <Form style={styles.container} onSubmit={onSubmit}>
        <PasswordFields onSubmit={onSubmit} />
      </Form>
      <Button
        id='restore-password-save'
        disabled={isSubmitDisabled}
        type='transparent'
        style={styles.button}
        text='Сохранить и войти'
        onPress={onSubmit}
      />
    </LoginLayout>
  );
};
